interface MinMax {
  min: number;
  max: number;
}
interface Rules {
  name: string;
  questions: MinMax;
  calculations: MinMax;
}

export const helperTextByQuestion = (rules: Rules[]): string => {
  const { qRule, cRule } = getRuleByType(rules, 'calculations');

  if (qRule.min === 1 && qRule.max === 1 && cRule.min === 1 && cRule.max >= 1) {
    return `Select one question`;
  }
  if ((qRule.min === 1 && qRule.max === 1) || (cRule.min === 1 && cRule.max === 1)) {
    return `Select one question`;
  }
  if ((qRule.min === 1 && qRule.max > 1) || (cRule.min === 1 && cRule.max > 1)) {
    return `Select 1 - ${qRule.max} questions`;
  }
  if ((qRule.min === 0 && qRule.max === 1) || (cRule.min === 0 && cRule.max === 1)) {
    return `Optionally select one question`;
  }
  if ((qRule.min === 0 && qRule.max > 1) || (cRule.min === 0 && cRule.max > 1)) {
    return `Optionally select up to ${qRule.max} questions`;
  }
  return 'Select a question';
};

export const helperTextByCalculation = (rules: Rules[]): string => {
  const { qRule, cRule } = getRuleByType(rules, 'calculations');

  if (qRule.min === 1 && qRule.max === 1 && cRule.min === 1 && cRule.max >= 1) {
    return `Optionally select ${cRule.max} calculation${cRule.max > 1 ? 's' : ''}`;
  }
  if ((qRule.min === 1 && qRule.max === 1) || (cRule.min === 1 && cRule.max === 1)) {
    return `Select one calculation`;
  }
  if ((qRule.min === 1 && qRule.max > 1) || (cRule.min === 1 && cRule.max > 1)) {
    return `Select 1 - ${cRule.max} calculations`;
  }
  if ((qRule.min === 0 && qRule.max === 1) || (cRule.min === 0 && cRule.max === 1)) {
    return `Optionally select one calculation`;
  }
  if ((qRule.min === 0 && qRule.max > 1) || (cRule.min === 0 && cRule.max > 1)) {
    return `Optionally select up to ${cRule.max} calculations`;
  }

  return 'Select a calculation';
};

const getRuleByType = (rules: Rules[], ruleType: 'questions' | 'calculations') => {
  const qMaxVal = Math.max(...rules.map((r: Rules) => r.questions.max));
  const cMaxVal = Math.max(...rules.map((r: Rules) => r.calculations.max));
  const qRule =
    // eslint-disable-next-line prettier/prettier
    rules.find((r: Rules) => r.questions.max === qMaxVal)?.questions || ({} as Rules).questions;
  const cRule =
    rules.find((r: Rules) => r.calculations.max === cMaxVal)?.calculations ||
    ({} as Rules).calculations;
  return { qRule, cRule };
};
